import React from 'react';
// Zustand
import { useStore } from "../../zustand";
// MUI Components
import IconButton from "@material-ui/core/IconButton";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Tooltip from '@material-ui/core/Tooltip';
// Helpers
import { sendAnalyticsData } from '../../utility/handleAnalytics';
// Styles
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    exit_button: {
        position: 'fixed',
        top: 10,
        right: 10
    }
}));

export default function ExitBtn() {
    const classes = useStyles();
    const variant_id = useStore(state => state.variant_id);
    const { vList } = useStore.getState().variants_payload;
    const { origin, variant_session_id, product_session_id } = useStore.getState().settings;
    
    const _handleViewerClose = async () => {
        if(vList[variant_id].levar_exit_url) {
            await sendAnalyticsData({ event_type: 'viewer_page_exit' });
            window.location.assign(vList[variant_id].levar_exit_url);
        } else if(origin === 'external') {
            await sendAnalyticsData({ event_type: 'viewer_page_exit' });
            window.location.assign(`${vList[variant_id].referer}?variant=${variant_id}&variant_session_id=${variant_session_id}&product_session_id=${product_session_id}`);
        } else if(origin === 'shopify' || origin === 'bigc') { 
            window.parent.postMessage('levarViewerClose', '*');
        }
    };
    if(origin === 'static' || origin === null) {
        return null;
    }

    return (
        <div className={classes.exit_button}>
            <Tooltip title={'To Product Store'}>
                <IconButton onClick={_handleViewerClose} aria-label="Close">
                    <ExitToAppIcon />
                </IconButton>
            </Tooltip>
        </div>
    )
}